// components/StudentForm/StudentDetails.jsx
import React from 'react';
import DepartmentSkillsSelector from '../Staffrecord/Editform/DepartmentSkillsSelector';


const StudentDetails = ({
  formData,
  onDepartmentChange,
  onSkillsChange,
  showToast,
  onFormDataChange,
  locationsData = {},
  trainers = [],

}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;

    onFormDataChange(prev => {
      let updated = { ...prev, [name]: value };

      if (name === "readyForPlacement") {
        updated.placementStatus = value === "Yes"
          ? "Awaiting for placement"
          : null;
      }

      return updated;
    });
  };


  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value;
    onFormDataChange(prev => ({
      ...prev,
      location: selectedLocation,
      branch: '',
      staffAssigned: '',
      mentorName: ''
    }));
  };

  const handleStaffChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange(prev => {
      const updatedState = {
        ...prev,
        [name]: value,
      };

      // Auto-fill mentor and staff details when staff is assigned
      if (name === "staffAssigned") {
        const selectedStaff = trainers.find(t => t.emp_name === value);

        console.log('Selected Staff:', selectedStaff); // 👈 Add this here

        if (selectedStaff) {
          updatedState.mentorName = selectedStaff.emp_name;
          updatedState.staffAssignedId = selectedStaff.emp_id;
          updatedState.mentorId = selectedStaff.emp_id;
          updatedState.mentorNumber = selectedStaff.contact_num;
        } else {
          updatedState.mentorName = "";
          updatedState.staffAssignedId = "";
          updatedState.mentorId = "";
          updatedState.mentorNumber = "";
        }
      }

      return updatedState;
    });
  };

  const handleMentorChange = (e) => {
    const { value } = e.target;
    onFormDataChange(prev => {
      const updatedState = { ...prev, mentorName: value };
      const selectedMentor = trainers.find(t => t.emp_name === value);
      console.log('Selected Mentor:', selectedMentor);

      if (selectedMentor) {
        updatedState.mentorId = selectedMentor.emp_id;
        updatedState.mentorNumber = selectedMentor.contact_num;
      } else {
        updatedState.mentorId = "";
        updatedState.mentorNumber = "";
      }

      return updatedState;
    });
  };
  // Add this handler inside StudentDetails component
const handleResumeUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  // Store the raw file object, don't upload yet
  onFormDataChange(prev => ({ 
    ...prev, 
    resumeFile: file,          // raw file for later upload
    resumePath: file.name      // just for UI validation check
  }));
};
  return (
    <div className="form-section">

      <div className="section-content">
        {/* Name */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">
              Name <span className="mandatory">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
              required
              className="input"
            />
          </div>
          <div className="form-group">
            <label className="label">
              Ready for Placement<span className="mandatory">*</span>
            </label>
            <select
              name="readyForPlacement"
              value={formData.readyForPlacement || ''}
              onChange={handleChange}
              className="input select"
              required
            >
              <option value="" disabled>
                Choose an option
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          {/* Resume Upload - shown only when Ready for Placement is Yes */}
          {formData.readyForPlacement === 'Yes' && (
            <div className="form-row">
              <div className="form-group">
                <label className="label">
                  Resume <span className="mandatory">*</span>
                </label>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleResumeUpload}
                  className="input"
                />
                {formData.resumePath && (
                  <small style={{ color: 'green', marginTop: '4px', display: 'block' }}>
                    ✓ Resume uploaded successfully
                  </small>
                )}
                {!formData.resumePath && (
                  <small style={{ color: 'red', marginTop: '4px', display: 'block' }}>
                    Resume is required for placement-ready students
                  </small>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Contact & Email */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">
              Contact Number <span className="mandatory">*</span>
            </label>
            <input
              type="text"
              name="contactNo"
              value={formData.contactNo || ''}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                onFormDataChange(prev => ({ ...prev, contactNo: value }));
              }}
              maxLength={10}
              required
              className="input"
            />
          </div>

          <div className="form-group">
            <label className="label">Email<span className="mandatory">*</span></label>
            <input
              type="email"
              name="email"
              value={formData.email || ''}
              onChange={handleChange}
              className="input"
              required
            />
          </div>
        </div>

        {/* Student Progress Status */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">
              Student Progress Status <span className="mandatory">*</span>
            </label>
            <select
              name="studentProgressStatus"
              value={formData.studentProgressStatus || 'Course In Progress'}
              onChange={handleChange}
              required
              className="input select"
            >
              <option value="Course In Progress">Course In Progress</option>
              <option value="Course Completed">Course Completed</option>
              <option value="Discontinued">Discontinued</option>
            </select>
          </div>

          <div className="form-group">
            <label className="label">Gender<span className="mandatory">*</span></label>
            <select
              name="gender"
              value={formData.gender || ''}
              onChange={handleChange}
              className="input select"
              required
            >
              <option value="">Select the Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
        </div>

        {/* Location & Branch */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">
              Location <span className="mandatory">*</span>
            </label>
            <select
              name="location"
              value={formData.location || ''}
              onChange={handleLocationChange}
              required
              className="input select"
            >
              <option value="">Select Location</option>
              {Object.keys(locationsData).map((location) => (
                <option key={location} value={location}>
                  {location}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">
              Branch <span className="mandatory">*</span>
            </label>
            <select
              name="branch"
              value={formData.branch || ''}
              onChange={handleChange}
              required
              disabled={!formData.location}
              className={`input select ${!formData.location ? 'disabled' : ''}`}
            >
              <option value="">Select Branch</option>
              {formData.location && locationsData[formData.location]?.branches.map((branch) => (
                <option key={branch} value={branch}>
                  {branch}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Staff Assigned & Mentor */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">
              Staff Assigned <span className="mandatory">*</span>
            </label>
            <select
              name="staffAssigned"
              value={formData.staffAssigned || ''}
              onChange={handleStaffChange}
              required
              disabled={!formData.branch}
              className={`input select ${!formData.branch ? 'disabled' : ''}`}
            >
              <option value="">Select Staff</option>
              {trainers
                .filter(staff => staff.role?.toLowerCase() === "trainer")
                .map((staff) => (
                  <option key={staff.emp_id} value={staff.emp_name}>
                    {staff.emp_name}
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label className="label">Mentor Name</label>
            <select
              name="mentorName"
              value={formData.mentorName || ''}
              onChange={handleMentorChange}
              disabled={!formData.branch}
              className={`input select ${!formData.branch ? 'disabled' : ''}`}
            >

              <option value="">Select Mentor</option>
              {trainers
                .filter(staff => staff.role?.toLowerCase() === "trainer")
                .map((staff) => (
                  <option key={staff.emp_id} value={staff.emp_name}>
                    {staff.emp_name}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group full-width">
            <DepartmentSkillsSelector
              department={formData.department}
              skillsKnown={formData.skillsKnown}
              onDepartmentChange={onDepartmentChange}
              onSkillsChange={onSkillsChange}
              showToast={showToast}
              departmentRequired={true}
              skillsRequired={true}
              layout="horizontal"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;